<div class="share-modal-wrapper">
  <div class="close-modal" (click)="closeModal()">&times;</div>
  <share-view [shareUrl]="shareUrl" [shareUrls]="shareUrls" [shareSource]="shareSource" (closeModal)="closeModal()"></share-view>
</div>